var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortlistedStIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3335,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CCFBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.3335,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0FDF9",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3845 31.5H23.3335C21.1244 31.5 19.3335 33.2909 19.3335 35.5C19.3335 36.6046 20.2289 37.5 21.3335 37.5H30.0171M30.3335 32.1662L32.6747 34.5049C33.8228 32.4972 35.4269 30.8025 37.3335 29.5M31.3335 23.5C31.3335 25.7091 29.5426 27.5 27.3335 27.5C25.1244 27.5 23.3335 25.7091 23.3335 23.5C23.3335 21.2909 25.1244 19.5 27.3335 19.5C29.5426 19.5 31.3335 21.2909 31.3335 23.5Z",
    stroke: "#15B79E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlistedStIcon);
export default __webpack_public_path__ + "static/media/shortlisted_stIcon.6f557414a6917e7a55dadc4480332298.svg";
export { ForwardRef as ReactComponent };